import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "input", "form", "results", "status"]

  connect() {
    this.initialResults = this.resultsTarget.innerHTML
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  open() {
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
    this.inputTarget.focus()
  }

  close() {
    this.dialogTarget.close()
    this.closed()
  }

  closed() {
    clearTimeout(this.timer)
    this.inputTarget.value = ""
    this.resultsTarget.innerHTML = this.initialResults
    this.resultsTarget.hidden = false
    this.statusTarget.textContent = ""
  }

  backdrop(event) {
    if (event.target !== this.dialogTarget) return
    const rect = this.dialogTarget.getBoundingClientRect()
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close()
  }

  shortcut(event) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
      event.preventDefault()
      this.open()
    }
  }

  schedule() {
    clearTimeout(this.timer)
    this.resultsTarget.hidden = true
    if (this.inputTarget.value.trim().length < 3) {
      this.resultsTarget.innerHTML = this.initialResults
      this.resultsTarget.hidden = false
      this.statusTarget.textContent = ""
      return
    }
    this.statusTarget.textContent = "Buscando…"
    this.timer = setTimeout(() => this.formTarget.requestSubmit(), 300)
  }

  submit(event) {
    clearTimeout(this.timer)
    if (this.inputTarget.value.trim().length < 3) event.preventDefault()
  }

  beforeRender(event) {
    this.acceptedResponse = event.detail.newFrame.dataset.query === this.inputTarget.value.trim()
    if (!this.acceptedResponse) event.detail.render = () => {}
  }

  loaded() {
    if (!this.acceptedResponse) return
    this.resultsTarget.hidden = false
    this.statusTarget.textContent = ""
  }

  error(event) {
    event.preventDefault()
    this.statusTarget.textContent = "Não foi possível buscar. Tente novamente."
  }
}
